"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _H = _interopRequireDefault(require("../Typography/H2"));

var _P = _interopRequireDefault(require("../Typography/P"));

var _CircledChevron = _interopRequireDefault(require("../Chevron/CircledChevron"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin-top: ", ";\n\t", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\tpadding: 0 ", " 0 0;\n\tline-height: 2rem;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: #fff;\n\tpadding: ", ";\n\tborder-bottom: ", " solid ", ";\n\n\t&:last-child {\n\t\tborder: 0;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tpadding: 0;\n\twidth: 2rem;\n\theight: 2rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Expand = _styledComponents.default.div(_templateObject());

Expand.displayName = 'Expand';

var Container = _styledComponents.default.div(_templateObject2(), _spacing.default.s2, _vars.default.borderWidth, _colors.default.borderColor);

Container.displayName = 'Container';

var Header = _styledComponents.default.div(_templateObject3(), _spacing.default.s6);

Header.displayName = 'Header';

var Content = _styledComponents.default.div(_templateObject4(), _spacing.default.s2, function (props) {
  return props.flexContent && "\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t";
});

Content.displayName = 'Content';

var Expando =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Expando, _Component);

  function Expando(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    _this.state = {
      expanded: props.openByDefault
    };
    return _this;
  }

  var _proto = Expando.prototype;

  _proto.toggle = function toggle() {
    var _this2 = this;

    this.setState(function (_ref) {
      var expanded = _ref.expanded;
      return {
        expanded: !expanded
      };
    }, function () {
      if (_this2.props.onToggle) {
        _this2.props.onToggle(_this2.state.expanded);
      }
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        description = _this$props.description,
        children = _this$props.children,
        flexContent = _this$props.flexContent,
        props = _objectWithoutPropertiesLoose(_this$props, ["title", "description", "children", "flexContent"]);

    var expanded = this.state.expanded;
    return _react.default.createElement(Container, props, _react.default.createElement(Header, null, _react.default.createElement(_H.default, null, title), description && _react.default.createElement(_P.default, null, description), _react.default.createElement(Expand, null, _react.default.createElement(_CircledChevron.default, {
      "aria-label": "expand section",
      onClick: this.toggle,
      expanded: expanded,
      "data-testid": "toggle button"
    }))), expanded && _react.default.createElement(Content, {
      "data-testid": "Content",
      flexContent: flexContent
    }, children));
  };

  return Expando;
}(_react.Component);

Expando.displayName = 'Expando';
Expando.propTypes = {
  title: _propTypes.string.isRequired,
  description: _propTypes.node,
  children: _propTypes.node.isRequired,
  onToggle: _propTypes.func,
  openByDefault: _propTypes.bool,
  flexContent: _propTypes.bool
};
Expando.defaultProps = {
  description: undefined,
  onToggle: undefined,
  openByDefault: false,
  flexContent: false
};
var _default = Expando;
exports.default = _default;